import { decoder } from './utils';
import CONFIGS from '../common/configs';
import '../chat-assistant-link/styles.scss';

const CDN_URL = 'https://cdn.static.hsmoa.com/ok-sdk';
const USER_API = 'https://chat-user.buzzni.com';

let storage: Storage;
let iw: Window;
let entry,
  entryBtn: HTMLElement,
  plugin: HTMLElement,
  dimmed: HTMLElement,
  isOpen: boolean;

function fetchToken() {
  const access_token = getCookie('buzzni_shopping_gpt_access_token');
  const { client_id, d_key } = (window as any).ok_config ?? {};

  if (!!access_token) {
    setTimeout(() => {
      iw.postMessage({ buzzni_shopping_gpt_access_token: access_token }, '*');
    }, 1000);
  } else {
    (async () => {
      const url = `${USER_API}/user/v1/device/login`;
      // const id = crypto.randomUUID(); -> http 프로토콜에서 동작하지 않음
      const data = {
        device_id: d_key,
        client_id,
      };
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(data),
      });

      const result = await response.json();
      const {
        access_token,
        access_token_exp,
        refresh_token,
        refresh_token_exp,
      } = result;

      setCookie(
        'buzzni_shopping_gpt_access_token',
        access_token,
        access_token_exp
      );
      setCookie(
        'buzzni_shopping_gpt_refresh_token',
        refresh_token,
        refresh_token_exp
      );
      iw.postMessage({ buzzni_shopping_gpt_access_token: access_token }, '*');
    })();
  }
}

function onLoadComplete() {
  iw = (document.querySelector('#ok-iframe') as HTMLIFrameElement | undefined)
    ?.contentWindow;
  fetchToken();
}

function fetchRefreshAccessToken(refreshToken?: string) {
  if (refreshToken) {
    (async () => {
      const url = `${USER_API}/user/v1/refresh/accesstoken`;
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${refreshToken}`,
        },
      });

      const result = await response.json();
      const { access_token, access_token_exp } = result;
      setCookie(
        'buzzni_shopping_gpt_access_token',
        access_token,
        access_token_exp
      );
      iw?.postMessage({ buzzni_shopping_gpt_access_token: access_token }, '*');
    })();
  }
}

function fetchRefreshRefreshToken(refreshToken: string) {
  (async () => {
    const url = `${USER_API}/user/v1/refresh/refreshtoken`;
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${refreshToken}`,
      },
    });

    const result = await response.json();
    const { refresh_token, refresh_token_exp } = result;
    setCookie(
      'buzzni_shopping_gpt_access_token',
      refresh_token,
      refresh_token_exp
    );
  })();
}

function statistics(data: Record<string, any> | undefined) {
  const STAT_KEY = process.env.ANALYTICS_KEY;
  if (!STAT_KEY) return;

  (async () => {
    const token = getCookie('buzzni_shopping_gpt_access_token');
    const { client_id, mode } = (window as any).ok_config ?? {};
    const STAT_URL =
      (mode === 'release'
        ? 'https://shopping-gpt-stat.buzzni.com'
        : 'https://dev-shopping-gpt-stat.buzzni.com') + '/log/record';
    const commonParams = {
      company: client_id || 'oksoon',
      user_token: decoder(token)?.user_token || '',
    };

    const response = await fetch(STAT_URL, {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': STAT_KEY,
      },
      method: 'POST',
      body: JSON.stringify({ ...commonParams, ...(data ?? {}) }),
    });

    const result = await response.json();
    if (result) {
      return;
    }
  })();
}

function showPlugin() {
  fetchRefreshAccessToken(getCookie('buzzni_shopping_gpt_refresh_token'));
  setTimeout(() => {
    plugin.style.visibility = 'visible';
    plugin.style.opacity = '1';

    if (isMobile() && !!dimmed) {
      dimmed.classList.toggle('ok-dimmed--visible');
      dimmed.classList.remove('ok-dimmed--hidden');
    }
  }, 300);

  isOpen = true;
  setEntryButtonImage();
  iw?.postMessage({ buzzni_shopping_gpt_new_chat_open: true }, '*');
}

function hidePlugin() {
  plugin.style.opacity = '0';
  plugin.style.visibility = 'hidden';
  if (isMobile() && !!dimmed) {
    dimmed.classList.toggle('ok-dimmed--hidden');
    dimmed.classList.remove('ok-dimmed--visible');
  }

  isOpen = false;
  setEntryButtonImage();
}

function getOriginalUrl() {
  const { mode, light }: { mode: string; light: boolean } =
    (window as any).ok_config ?? {};
  const OKSOON = 'https://oksoon.ai';
  return (
    {
      local: 'http://localhost:3000',
      stage: light
        ? 'https://ok-soon-ai-front-sdk-git-stage-sajamarket.vercel.app'
        : 'https://oksoon-stage.buzzni.com',
      release: light
        ? 'https://ok-soon-ai-front-sdk-git-stage-sajamarket.vercel.app'
        : OKSOON, // TODO: 실서버로 수정하기
    }[mode] ?? OKSOON
  );
}

function handleMessage(event: MessageEvent<any>) {
  const data = event.data;
  const {
    buzzni_shopping_gpt_token_error: token_error,
    buzzni_shopping_gpt_close_content: close_content,
    buzzni_shopping_gpt_conversation_id: conversation_id,
    buzzni_shopping_gpt_stat_params: stat_params,
  } = data;
  if (!!stat_params) {
    statistics(stat_params);
  }

  if (!!token_error) {
    fetchRefreshAccessToken();
    return;
  }

  if (!!close_content) {
    hidePlugin();
    return;
  }

  if (!!conversation_id) {
    storage.setItem('c_id', conversation_id);
    return;
  }
}

function debounce(callback: () => void, delay?: number) {
  let timer: NodeJS.Timeout;
  return function () {
    if (!timer) {
      timer = setTimeout(() => {
        callback();
        timer = undefined;
      }, delay ?? 300);
    }
  };
}

function handleResize() {
  const _isMobile = isMobile();
  if (plugin) {
    const { m_right, m_bottom } = (window as any).ok_config ?? {};
    const MOBILE_CLASSNAME = 'ok-plugin-script--mobile';
    if (!_isMobile) {
      plugin.style.right = `${m_right}px`;
      plugin.style.bottom = `${m_bottom + 56 + 8}px`;
      plugin.classList.remove(MOBILE_CLASSNAME);
    } else {
      plugin.style.bottom = '0';
      plugin.style.right = '0';
      if (!plugin.classList.contains(MOBILE_CLASSNAME)) {
        plugin.classList.add(MOBILE_CLASSNAME);
      }
    }
  }
  if (dimmed) {
    if (_isMobile) {
      const DIMMED_CLASSNAME = `ok-dimmed--${isOpen ? 'visible' : 'hidden'}`;
      const DIMMED_OPPOSITE_CLASSNAME = `ok-dimmed--${
        !isOpen ? 'visible' : 'hidden'
      }`;
      if (!dimmed.classList.contains(DIMMED_CLASSNAME)) {
        dimmed.classList.add(DIMMED_CLASSNAME);
      }
      dimmed.classList.remove(DIMMED_OPPOSITE_CLASSNAME);
    } else {
      const DIMMED_HIDDEN_CLASSNAME = `ok-dimmed--hidden`;
      if (!dimmed.classList.contains(DIMMED_HIDDEN_CLASSNAME) && isOpen) {
        dimmed.classList.add(DIMMED_HIDDEN_CLASSNAME);
      }
      dimmed.classList.remove(`ok-dimmed--visible`);
    }
  }
}

function setEntryButtonImage() {
  const { entry_image } = (window as any).ok_config ?? {};
  entryBtn.style.backgroundImage = `url("${
    isOpen ? `${CDN_URL}/down.svg` : entry_image
  }")`;

  entryBtn.classList[isOpen ? 'add' : 'remove']('ok-entry-btn--close');
}

function init() {
  const refresh_token = getCookie('buzzni_shopping_gpt_refresh_token');
  if (refresh_token) {
    fetchRefreshRefreshToken(refresh_token);
  }

  entry = document.getElementById('ok-entry');
  plugin = document.getElementById('ok-plugin-script');
  dimmed = document.getElementById('ok-dimmed');
  entryBtn = document.getElementById('ok-entry-btn');

  const { m_right, m_bottom } = (window as any).ok_config ?? {};
  entry.style.right = `${m_right}px`;
  entry.style.bottom = `${m_bottom}px`;
  setEntryButtonImage();
  handleResize();

  window.addEventListener('message', handleMessage);
  window.addEventListener('resize', debounce(handleResize));

  entryBtn.addEventListener('click', function () {
    isOpen ? hidePlugin() : showPlugin();
  });
  dimmed.addEventListener('click', function () {
    if (dimmed.style.visibility === 'visible') {
      hidePlugin();
    }
  });
}

function setCookie(
  name: string,
  value: string,
  exp: number,
  path?: string,
  domain?: string
) {
  let date = new Date();
  document.cookie = `${name}=${value}; Max-Age=${exp - unixtime(date)}; path=/`;
}

function getCookie(name: string) {
  let value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return value ? value[2] : null;
}

const unixtime = (date: Date, digit?: number) => {
  const today = date ? +date : +new Date();
  return today.toString().length === (digit ?? 108)
    ? today
    : Math.trunc(today / 1000);
};

function setLayout() {
  storage = window.sessionStorage;
  const { client_id, d_key, coach_image } = (window as any).ok_config ?? {};

  const html = document.createElement('div');
  html.id = 'ok-plugin';
  html.innerHTML = /*html*/ `
  <div id="ok-entry">
    ${
      !!coach_image
        ? /*html*/ `<div id="ok-entry-coach">
    <img src="${coach_image}" alt="" /></div>`
        : ''
    }
    <div id="ok-entry-btns">
      <button id="ok-entry-btn" />
    </div>
  </div>
  <div id="ok-dimmed"></div>
  <div id="ok-plugin-script">
    <iframe
      id="ok-iframe"
      src="${getOriginalUrl()}/chat?${
    storage.getItem('c_id')
      ? 'conversation=' + storage.getItem('c_id') + '&'
      : ''
  }shop=${client_id}&d_key=${d_key}"
      width="100%"
      height="100%"
      frameborder="0"
      loading="lazy"
    />
  </div>`;

  document.body.append(html);
  document
    .getElementById('ok-iframe')
    ?.addEventListener('load', onLoadComplete);
}

function isMobile() {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) || window.innerWidth < 768
  );
}

function setStyles() {
  const { mode, client_id } = (window as any).ok_config;
  const styleSheet = document.createElement('link');
  styleSheet.rel = 'stylesheet';
  styleSheet.type = 'text/css';
  styleSheet.href =
    `${CDN_URL}/entries/${mode === 'local' ? 'stage' : mode}/` +
    'chat-assistant.css';
  document.head.append(styleSheet);

  if (CONFIGS[client_id]?.palette) {
    [
      { label: 'bai-primary', value: CONFIGS[client_id].palette.primary },
    ].forEach(({ label, value }) => {
      document.documentElement.style.setProperty(`--${label}`, value);
    });
  }
}

(function () {
  let w = window as any;
  w.ok_config = {
    client_id: document.currentScript.getAttribute('data-shop'), // client_id는 리소스 파일명과 일치 시킨다
    m_right: Number(document.currentScript.getAttribute('data-right') ?? 24), // 모바일 환경의 아이콘 우측 여백
    m_bottom: Number(document.currentScript.getAttribute('data-bottom') ?? 24), // 모바일 환경의 아이콘 하단 여백
    entry_image:
      document.currentScript.getAttribute('data-entry-image') ??
      `${CDN_URL}/hsmoa_entry.png`,
    coach_image: document.currentScript.getAttribute('data-coach-image'),
    d_key: document.currentScript.getAttribute('data-d-key') ?? '',
    mode: document.currentScript.getAttribute('data-mode') ?? 'release',
    light: false, // TODO
  };

  if (!w.ok_config.d_key) {
    console.error(`[ERROR]: data-d-key를 설정해주세요.`);
    return;
  }

  function load() {
    if (w.oksoonInitialized) {
      return;
    }
    w.oksoonInitialized = true;

    let d = document.createElement('div');
    d.id = 'ok-container';
    const body = document.getElementsByTagName('body')[0];
    body.appendChild(d);

    setStyles();
    setLayout();
    init();
  }

  if (document.readyState === 'complete') {
    load();
  } else {
    w.addEventListener('DOMContentLoaded', load);
    w.addEventListener('load', load);
  }
})();
